import React, { useState, useEffect, useCallback } from 'react';
import { useUsuariosStore } from '../../store/UsuariosStore';
import { Paper, Typography, Box, Stack, Pagination } from '@mui/material';

// Importando os componentes filhos
import FiltrosBusca from '../../components/FiltroBuscaUsusarios';
import TabelaUsuarios from '../../components/TabelaUsuarios';
import ModalEdicao from '../../components/ModalEdicaoUsuario';
import ConfirmDeleteModal from '../../components/ModalDeConfirmacao';


export default function UsuariosPage() {
    // Pegando estado e ações da store
    const {
        usuarios,
        paginaAtual,
        ultimaPagina,
        carregando,
        deletingId,
        fetchUsuarios,
        searchUsuarios,
        DeletarUsuario,
        SalvarUsuario,
        Createusuario,
        setIdUserDelete
    } = useUsuariosStore();

    // Estado local para controlar o modal de edição
    const [modalAberto, setModalAberto] = useState(false);
    const [modalCriacaoAberto, setmodalCriacaoAberto] = useState(false);
    const [ususarioSelecionado, setUsuarioselecionado] = useState(null);
    const [ModalConfirmacao, setModalConfirmacao] = useState(false);
    const [msgModalConfirmacao, setMsgModalConfirmacao] = useState('');

    // Busca inicial dos dados quando o componente é montado
    useEffect(() => {
        fetchUsuarios();
    }, [fetchUsuarios]);

    // Funções de callback otimizadas com useCallback
    const handleBusca = useCallback((filtros) => {
        searchUsuarios(filtros);
    }, [searchUsuarios]);

    const handleLimparBusca = useCallback(() => {
        fetchUsuarios(1); // Volta para a primeira página ao limpar
    }, [fetchUsuarios]);

    const handleAbrirModal = useCallback((usuario) => {
        setUsuarioselecionado(usuario);
        setModalAberto(true);
    }, []);

    const handleFecharModal = useCallback(() => {
        setModalAberto(false);
        setUsuarioselecionado(null);
    }, []);

    const handleFecharModalConfirmacao = useCallback(() => {
        setModalConfirmacao(false)
        setMsgModalConfirmacao("");
    }, [])

    const handleSalvarEdicao = useCallback(async (dadosusuario) => {
        await SalvarUsuario(dadosusuario);
        handleFecharModal();
    }, [SalvarUsuario, handleFecharModal]);

    const handleAbrirModalConfirmacao = useCallback((id_usuario) => {
        setIdUserDelete(id_usuario)
        setModalConfirmacao(true)
        setMsgModalConfirmacao('Deseja realmente excluir esse usuário ?');
    }, [])

    const handleConfirmarExlusao = useCallback(async () => {
        handleFecharModalConfirmacao();
        setMsgModalConfirmacao('');
        await DeletarUsuario();
        setIdUserDelete(0);
    }, []);


    const handlePageChange = useCallback((event, page) => {
        fetchUsuarios(page);
    }, [fetchUsuarios]);

    return (
        <Paper elevation={3} sx={{ p: 3, borderRadius: 3, width: '99%', backgroundColor: 'transparent' }}>
            <Typography variant="h5" component="h1" gutterBottom>
                Gerenciamento de usuários
            </Typography>

            <FiltrosBusca
                onSearch={handleBusca}
                onClear={handleLimparBusca}
                oncreate={handleAbrirModal}
            />

            <Box sx={{ mt: 4 }}>
                <TabelaUsuarios
                    usuarios={usuarios}
                    onEdit={handleAbrirModal}
                    onDelete={handleAbrirModalConfirmacao}
                    carregandoState={{ carregando, deletingId }}
                />
            </Box>

            <Stack spacing={2} sx={{ mt: 3, alignItems: 'center' }}>
                <Pagination
                    page={paginaAtual}
                    count={ultimaPagina}
                    onChange={handlePageChange}
                    color="primary"
                    shape="rounded"
                    disabled={carregando !== 'idle'}
                />
            </Stack>

            {/* MODAL DE EDIÇÃO */}
            {modalAberto && (
                <ModalEdicao
                    open={modalAberto}
                    onClose={handleFecharModal}
                    onSave={handleSalvarEdicao}
                    usuario={ususarioSelecionado}
                    isLoading={carregando === 'updating'}
                />
            )}

            {
                ModalConfirmacao && (
                    <ConfirmDeleteModal
                        mensagem={msgModalConfirmacao}
                        open={ModalConfirmacao}
                        onClose={handleFecharModalConfirmacao}
                        titulo={'Atenção'}
                        onConfirm={() => { handleConfirmarExlusao() }}
                    />
                )
            }
        </Paper>
    );
}